import { Model } from "@vuex-orm/core";

export default class AccountPhone extends Model {
  static entity = "accountPhones";

  static fields() {
    return {
      createdAt: this.attr(),
      updatedAt: this.attr(),
      id: this.attr(),
      isDirty: this.boolean(false),
      phoneNumber: this.attr(),
      displayName: this.attr(),
      type: this.attr()
    };
  }

  static mutators() {
    return {
      createdAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      updatedAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      }
    };
  }
}
